import { render, staticRenderFns } from "./social_upload.vue?vue&type=template&id=8666f09a&scoped=true&"
import script from "./social_upload.vue?vue&type=script&lang=js&"
export * from "./social_upload.vue?vue&type=script&lang=js&"
import style0 from "./social_upload.vue?vue&type=style&index=0&id=8666f09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8666f09a",
  null
  
)

export default component.exports